import { PREFIX_ACTIONS } from './constants';
import { IApiGetDemoDataParam, IApiGetLibraryMediaParam } from '../interfaces/api';
import { createAsyncAction } from 'services/actionConfigs';

const getDemoData = createAsyncAction<IApiGetDemoDataParam>(PREFIX_ACTIONS + 'getDemoData');
const getListLibraryMedia = createAsyncAction<{ path: string, keySearch?: string }>(PREFIX_ACTIONS + 'getListLibraryMedia');
const getLibraryLinks = createAsyncAction<IApiGetLibraryMediaParam>(PREFIX_ACTIONS + 'getLibraryLinks');
const getAllFoldersInStore = createAsyncAction<{ storeId: string }>(PREFIX_ACTIONS + 'getAllFoldersInStore');

/**
 * TODO:
 * please replace media to your feature name
 * ex:
 * mediaActions => bookingActions
 */
const mediaActions = {
  getDemoData,
  getListLibraryMedia,
  getLibraryLinks,
  getAllFoldersInStore,
};

export default mediaActions;

